import { useRef, useEffect } from 'react'
import { MainContainer } from '../../user/HomepageStarterEmail/styled'
import { Col, Row } from 'react-bootstrap'
import { Title } from '../../shared/simple/Title'
import { SubTitle } from '../../shared/simple/SubTitle'
import { useParams } from 'react-router'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { fileStatus } from '../../../constants/files'
import { StyledRow } from '../../user/styled'
import { FormProvider } from 'react-hook-form'
import { StyledFormTier } from '../../shared/simple/StyledFormTier'
import { usePersonFiles } from '../../../hooks/useFile'
import { useInitFormTier } from '../../../hooks/useFormTier'
import { useFormFiles } from '../../../hooks/useFile'
import { useFilesFields } from '../../../hooks/useFile'
import { Button } from '../../shared/simple/Button'
import { useTextLanguage } from '../../../hooks/useShared'
import { Fields } from '../Fields'
import { useSwitchDesign } from '../../../hooks/useSwitchDesign'
import useAltModule from '../../../hooks/useAltModule'
import { Loading } from '../../shared/Loading'
import { useCompletedForm } from '../../../hooks/useTier'
import { useDispatch } from 'react-redux'
import { setLoader } from '../../../redux/actions/shared'
import { useModule } from '../../../hooks/useTier'
import useAltFiles from '../../../hooks/useAltFiles'

const InnerContainer = styled.div`
	padding: 0px;
	color: white;
	width: 90%;
	height: 100%;
	margin: 0 auto !important;

	@media (min-width: 767px) {
		padding: 60px 40px;
	}

	& h1 {
		text-align: center
	}

`

const AltFiles = () => {
  const { description } = useTextLanguage();
  const { t } = useTranslation();
  const { codeTier } = useParams();
  const { files } = usePersonFiles(codeTier);
  const { tierFieldsFile, fileFields } = useFilesFields(files);
  const { loading, schemaTier } = useInitFormTier(fileFields);
  const { methods, onSubmit, onValidate } = useFormFiles(fileFields, schemaTier);
  const { isNewDesign } = useSwitchDesign()
  const { BackBtn } = useAltModule()
  useModule()
  useCompletedForm(methods);
  useAltFiles()
  
  return (
    <>
      {
        <>
          {loading && <Loading />}
          <MainContainer>
            <Col className="" 
              xl={{
                span:8
              }} 
              md={12} 
              xs={12}
            >
              <InnerContainer>
                {BackBtn}
                <Col className="p-4 pt-0 pb-3" xs={12}>
                  <Title>
                    {t("documents.identity")}&nbsp;-&nbsp;
                    {(codeTier === fileStatus.expired) ? t("documents.expired") : t("documents.rejected")}
                  </Title>
                </Col>
                <Col className="p-4 pt-0" xs={12}>
                  <StyledRow 
                    className="p-0"
                    isNewDesign={isNewDesign}
                  >
                    <FormProvider {...methods}>
                      <StyledFormTier
                        className="col-xs-12 p-3"
                        onSubmit={methods.handleSubmit(onSubmit)}
                      >
                        {tierFieldsFile.map(item => {
                          return (
                            <div
                              className="col-12 row"
                              style={{ display: (!item?.category?.show_category) && "none" }}
                              id={`module_${item?.category?.id}`}
                              key={`fragment_${item?.category?.unique_name}_${item?.category?.id}`}
                            >
                              {item?.category?.active && (
                                <SubTitle
                                  className="mb-2 mt-3"
                                  key={`subtitle_${item?.category?.unique_name}_${item?.category?.id}`}
                                >
                                  {item?.category?.[description]}
                                </SubTitle>
                              )}
                              <Fields
                                files={files}
                                fields={item?.fields}
                                key={`category_${item?.category?.unique_name}_${item?.category?.id}`}
                                loading={loading}
                              />
                            </div>
                          );
                        })}
                        <Row className="justify-content-center m-0">
                          <Col className="p-3 mt-5 mb-5" xs={12} md={6} xl={4}>
                            {loading
                              ? (
                                <Loading />
                              ) : (
                                <Button
                                  className="btn mb-0"
                                  color="first"
                                  name="btn_file"
                                  onClick={onValidate}
                                >
                                  {t("common.submit")}
                                </Button>
                              )
                            }
                          </Col>
                        </Row>
                      </StyledFormTier>
                    </FormProvider>
                  </StyledRow>
                </Col>
              </InnerContainer>
            </Col>
          </MainContainer>
        </>
      }
    </>
  )
}

export default AltFiles